import useSWR from 'swr'
import axios from 'utils/axios'
import { useEffect } from 'react'
import { useParams } from "react-router-dom"
import { useToken } from 'lib/use-token'
import { PIANO_AUTH_CRED  } from "lib/constants"

const redirectPath = `${process.env.NODE_ENV === "development" ? '/' : '/oppdb'}`;

export const useAuth = ({ middleware, redirectIfAuthenticated } = {}) => {

    const { setToken, removeToken } = useToken();

    let params = useParams();

    const { data: user, error, isValidating: isFetchingUser } = useSWR('/api/user', () =>
        axios.get('/user').then(res =>  res.data.data)
    )

    const csrf = () => axios.get('/sanctum/csrf-cookie')

    const authGoogle = async ({ setErrors, setIsLoadingGoogle, ...props }) => {
       setIsLoadingGoogle(true);
       setErrors();
        await csrf();
        
        const { tokenRes } = props;
        
        axios
            .post('/social/google/auth', tokenRes)
            .then((res) => {
                setToken(res.data.token);
                window.location.pathname = redirectPath;
            }).catch(error => {

                if(error && error.response){
                    setIsLoadingGoogle(false);
                    setErrors("Nous n'arrivons pas à vous connectez. On peut réessayer")
                }
            })
    }

    const register = async ({ middleware, setErrors, setStatus, setIsLoading, ...props }) => {
        await csrf()

        setErrors();
        setIsLoading(true);
        setStatus(null);
        
        axios
            .post('/register', props)
            .then((res) => {
                console.log("res", res);
                localStorage.setItem(PIANO_AUTH_CRED, res.data.token);
                setStatus("Your account has been created successfully. Please, check your email to verify your email.");
                setIsLoading(false);
            })
            .catch((errors) => {
                if(errors && typeof errors != 'undefined'){
                    setIsLoading(false);
                    console.log("errors", errors.response);
                    setErrors("Somethings went wrong. Try again !");
                }
            })
    }

    const login = async ({ setErrors, setStatus, setIsLoading, setOpenModal, ...props }) => {
        await csrf();

        setErrors();
        setStatus(null);
        setIsLoading(true);

        let params = new URL(document.location).searchParams;

        axios.post('/login', props).then( (res) => {

                if(!!!res.data.user.email_verified){
                    localStorage.setItem(PIANO_AUTH_CRED, res.data.token);
                    setStatus("Please, check your email to verify your email");
                    setIsLoading(false);
                }else{

                    let currentUrl = params.get("url"); 
                    setToken(res.data.token);
                    if(currentUrl){
                        window.location.href = currentUrl;
                    }else{
                        window.location.pathname = redirectPath;
                    }
                }
            })
            .catch((errors) => {
                if(errors && typeof errors != 'undefined'){
                    setIsLoading(false);
                    console.log("errors", errors.response);
                    setErrors("Somethings went wrong. Try again !");
                }

            })
    }

    const getVerifyToken = async({ setErrors, setStatus, setIsLoading, ...props  }) => {

        await csrf()

        setErrors('')
        setStatus(null)
        setIsLoading(true)

        axios
            .post('/get-verify-token', props )
            .then((res) => {
                setIsLoading(false)
                setStatus("Please, check your email to verify your email now.");
            })
            .catch((errors) => {
                if(errors && typeof errors != 'undefined'){
                    setIsLoading(false);
                    console.log("errors", errors.response);
                    setErrors("Somethings went wrong. Try again !");
                }
            })
    }

    const forgotPassword = async ({ setErrors, setStatus, setIsLoading, email }) => {

        await csrf()

        setErrors('')
        setStatus(null)
        setIsLoading(true)

        axios
            .post('/reset-password', { email })
            .then((res) => {
                setIsLoading(false)
                setStatus(res.data.message);
            })
            .catch((errors) => {
                if(errors && typeof errors != 'undefined'){
                    setIsLoading(false);
                    console.log("errors", errors.response);
                    setErrors("Somethings went wrong. Try again !");
                }
            })
    }

    const resetPassword = async ({ setErrors, setStatus, setIsLoading, ...props }) => {
        
        await csrf();

        setErrors([]);
        setStatus(null);
        setIsLoading(true);

        axios
            .post('/change-password', { ...props })
            .then(response => {
                
                if(response.status === 200) {
                    setStatus("Your password has successfully been changed. You will be redirected to sign in to your account !");
                    setTimeout(() => {
                        window.location.pathname = '/oppdb/auth/login';
                    }, 5000);
                }
            }).catch(errors => {
                if(errors && typeof errors != 'undefined'){
                    setIsLoading(false);
                    console.log("errors", errors.response);
                    setErrors("The password must contain upper case,lower case, numbers and special characters.");
                }
            })
    }

    const resendEmailVerification = async ({ setStatus, setIsLoading }) => {

        setIsLoading(true);

        await axios
            .post('/email/verification-notification')
            .then(response => {
                setIsLoading(false)
                setStatus(response.data.status)
            }).catch(() => {
                setIsLoading(false)
            })
    }

    const ifIsVerify = async (  ) => {

        await axios
            .post('/api/email-is-verify')
            .then((response) => {
                console.log("response email", response.status);
            }).catch((error) => {
                console.log("error email", error.response);
            })
    }

    const logout = async () => {
        if (! error) {
            removeToken();
            window.location.pathname = redirectPath
            await axios.get('/logout').then((res) => {
                if(res.status == 200){
                    removeToken();
                    window.location.pathname = redirectPath
                }
            })
        }
    }

    useEffect(() => {
        if (middleware == 'guest' && redirectIfAuthenticated && user) 
        if (middleware == 'auth' && error) logout()
    }, [user, error])

    return {
        user,
        authGoogle,
        register,
        login,
        resetPassword,
        forgotPassword,
        resendEmailVerification,
        ifIsVerify,
        logout,
        getVerifyToken,
        isFetchingUser
    

    }
}
